<template>
    <vue-recaptcha
        ref="recaptcha"
        :sitekey="recaptchaSiteKey"
        @verify="$emit('update:modelValue', $event)"
    ></vue-recaptcha>
</template>
<script>
import { VueRecaptcha } from "vue-recaptcha";
import { usePage } from '@inertiajs/inertia-vue3';

export default {
    components: {
        VueRecaptcha
    },
    props: {
        modelValue: String
    },
    computed: {
        recaptchaSiteKey() {
            return usePage().props.value.recaptcha.site_key;
        }
    },
    methods: {
        reset() {
            this.$refs.recaptcha.reset();
        }
    }
};
</script>


<style lang="scss" scoped>

</style>
